module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.23567",
      "conversations-internal-schema": "static-1.11524",
      "head-dlb": "static-1.4043",
      "hs-test-utils": "static-1.6885",
      "hubspot-url-utils": "static-1.3218",
      "HubStyleTokens": "static-2.10373",
      "I18n": "static-7.1393",
      "jasmine-runner": "static-1.5276",
      "quartz": "static-1.5631",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "webpack-env": "static-1.54",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.463",
      "visitor-ui-component-library": "static-1.5064",
      "enviro": "static-4.306",
      "hs-promise-rejection-tracking": "static-1.4356",
      "PortalIdParser": "static-2.284",
      "raven": "static-3.4818",
      "raven-hubspot": "static-1.5125",
      "bend-plugin-trellis-migration": "static-1.2510",
      "moment": "static-3.26",
      "hub-http": "static-1.4807",
      "immutable": "static-2.19",
      "quartz-core": "static-1.4850",
      "transmute": "static-2.29",
      "HeadJS": "static-2.579",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.6082",
      "framer-motion": "static-1.41",
      "hs-test-utils-bend-plugin": "static-1.1996",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.121",
      "foundations-theming": "static-1.3194",
      "i18n-data": "static-1.198",
      "metrics-js": "static-1.8648",
      "moment-timezone": "static-5.51",
      "react-utils": "static-2.4381",
      "jasmine": "static-4.3218",
      "quartz-core-utils": "static-1.2498",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.39",
      "styled-components": "static-2.64",
      "UIComponents": "static-3.7320",
      "visitor-ui-component-library-icons": "static-1.4875",
      "copilot-toolkit": "static-1.6750",
      "dispatcher": "static-1.113",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.651",
      "hub-http-shared-msw-handlers": "static-1.7148",
      "hubspotter-http": "static-1.3639",
      "hubspotter-http-shared-msw-handlers": "static-1.7146",
      "icons": "static-2.592",
      "mobile-manifest-mixins": "static-1.350",
      "platform-navigation-bootstrap": "static-1.11288",
      "quick-fetch": "static-1.2772",
      "react-rhumb": "static-1.15454",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.332",
      "bend-plugin-foundations-components": "static-1.2351",
      "floating-ui": "static-1.29",
      "foundations-assets": "static-1.3796",
      "foundations-theming-specialty": "static-1.911",
      "hs-story-utils": "static-1.8262",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.74",
      "tanstack-table": "static-1.23",
      "ui-images": "static-2.858",
      "bend-plugin-foundations-theming": "static-1.1677",
      "foundations-theming-base": "static-1.2179",
      "classnames": "static-2.10",
      "cssUtils": "static-1.509",
      "HubStyle": "static-2.10681",
      "chatspot-client-types": "static-1.8729",
      "chatspot-core": "static-1.15997",
      "ts-schema": "static-1.3193",
      "sassPrefix": "static-1.132",
      "platform-infra-nav-components": "static-1.6753",
      "react-input-autosize": "static-2.17",
      "hs-lodash": "static-4.45"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.23567",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11524",
      "head-dlb": "/head-dlb/static-1.4043",
      "hs-test-utils": "/hs-test-utils/static-1.6885",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3218",
      "HubStyleTokens": "/HubStyleTokens/static-2.10373",
      "I18n": "/I18n/static-7.1393",
      "jasmine-runner": "/jasmine-runner/static-1.5276",
      "quartz": "/quartz/static-1.5631",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.54",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.463",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5064",
      "enviro": "/enviro/static-4.306",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4356",
      "PortalIdParser": "/PortalIdParser/static-2.284",
      "raven": "/raven/static-3.4818",
      "raven-hubspot": "/raven-hubspot/static-1.5125",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2510",
      "moment": "/moment/static-3.26",
      "hub-http": "/hub-http/static-1.4807",
      "immutable": "/immutable/static-2.19",
      "quartz-core": "/quartz-core/static-1.4850",
      "transmute": "/transmute/static-2.29",
      "HeadJS": "/HeadJS/static-2.579",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.6082",
      "framer-motion": "/framer-motion/static-1.41",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1996",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.121",
      "foundations-theming": "/foundations-theming/static-1.3194",
      "i18n-data": "/i18n-data/static-1.198",
      "metrics-js": "/metrics-js/static-1.8648",
      "moment-timezone": "/moment-timezone/static-5.51",
      "react-utils": "/react-utils/static-2.4381",
      "jasmine": "/jasmine/static-4.3218",
      "quartz-core-utils": "/quartz-core-utils/static-1.2498",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.39",
      "styled-components": "/styled-components/static-2.64",
      "UIComponents": "/UIComponents/static-3.7320",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.4875",
      "copilot-toolkit": "/copilot-toolkit/static-1.6750",
      "dispatcher": "/dispatcher/static-1.113",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.651",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7148",
      "hubspotter-http": "/hubspotter-http/static-1.3639",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7146",
      "icons": "/icons/static-2.592",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.350",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11288",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-rhumb": "/react-rhumb/static-1.15454",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.332",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2351",
      "floating-ui": "/floating-ui/static-1.29",
      "foundations-assets": "/foundations-assets/static-1.3796",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.911",
      "hs-story-utils": "/hs-story-utils/static-1.8262",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.74",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-images": "/ui-images/static-2.858",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1677",
      "foundations-theming-base": "/foundations-theming-base/static-1.2179",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.509",
      "HubStyle": "/HubStyle/static-2.10681",
      "chatspot-client-types": "/chatspot-client-types/static-1.8729",
      "chatspot-core": "/chatspot-core/static-1.15997",
      "ts-schema": "/ts-schema/static-1.3193",
      "sassPrefix": "/sassPrefix/static-1.132",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6753",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "hs-lodash": "/hs-lodash/static-4.45"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};